<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout align-center justify-center row fill-heigh>
          <!-- <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                        {{loggedUser.name}}
                    </v-flex>
                    -->
          <v-flex xs2 md2 class="text-lg-left" v-if="hasSellers">
            <v-combobox
              v-model="seller"
              :items="this.sellers"
              item-text="name"
              item-value="email"
              label="Vendedores"
            ></v-combobox>
          </v-flex>
          <v-flex xs3 md3 class="text-lg-left">
            <v-text-field
              v-model="email"
              label="Email"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs2 md2 class="text-lg-left">
            <v-text-field
              v-model="cpf"
              label="CPF"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs2 md2 class="text-lg-left">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computed_dt_inicialFormatted"
                  label="Data Inicial"
                  hint="DD/MM/AAAA"
                  persistent-hint
                  prepend-icon="event"
                  locale="pt-br"
                  @blur="dt_inicial = parseDate(dt_finalFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                dark
                v-model="dt_inicial"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <!-- <v-text-field
                            v-model="dt_inicial"
                            label="Data Inicial"
                            class="purple-input"
                            @keyup.enter="_search"
                        /> -->
          </v-flex>
          <v-flex xs2 md2 class="text-lg-left">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computed_dt_finalFormatted"
                  label="Data Final"
                  hint="DD/MM/AAAA"
                  persistent-hint
                  prepend-icon="event"
                  locale="pt-br"
                  @blur="dt_final = parseDate(dt_finalFormatted)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                dark
                v-model="dt_final"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
            <!-- <v-text-field
                            v-model="dt_final"
                            label="Data Final"
                            class="purple-input"
                            @keyup.enter="_search"
                        /> -->
          </v-flex>
          <v-flex xs2 md2 class="text-lg-left">
            <v-combobox
              v-model="status_filter"
              :items="status_list"
              item-text="label"
              item-value="status"
              label="Status"
            ></v-combobox>
          </v-flex>
          <!-- <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                        <v-select
                            :items="periodos"
                            v-model="periodo"
                            label="Periodo"
                            item-text="id"
                            item-value="value"
                        ></v-select>
                    </v-flex> -->

          <!-- <v-flex
                        xs3
                        md3
                    >
                        <v-select
                            v-model="status"
                            :items="status_list"
                            item-text="label"
                            item-value="value"
                            :menu-props="{ maxHeight: '400' }"
                            label="Status"
                            multiple
                            hint="Selecione o status"
                            persistent-hint
                            >
                        </v-select>
                    </v-flex> -->
          <v-flex xs2 md2 class="text-lg-left">
            <v-btn
              color="success"
              outline
              small
              slot="start"
              @click="_search"
              :disabled="!valid || loading"
              :loading="loading"
            >
              <v-icon left>search</v-icon>Buscar
            </v-btn>
          </v-flex>
          <v-flex xs2 md2 class="text-lg-left">
            <v-btn
              color="tertiary"
              small
              outline
              slot="start"
              @click="_clear"
              :disabled="!valid || loading"
            >
              <v-icon left>clear</v-icon>Limpar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
// import firestore from '../firebase/firestore';
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { getSellers } from "../../services/users";

export default {
  data: (vm) => ({
    // name: '',
    email: "",
    cpf: "",
    dt_inicial: new Date().toISOString().substr(0, 10),
    dt_inicialFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dt_final: new Date().toISOString().substr(0, 10),
    dt_finalFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    status_filter: "",
    valid: false,
    seller: "",
    sellers: [],
    periodo: 0,
    status: [],
    search: "",
    periodos: [
      { id: "Hoje", value: 0 },
      { id: "Útimos 7 dias", value: 7 },
      { id: "Útimos 30 dias", value: 30 },
      { id: "Útimos 60 dias", value: 60 },
    ],
    status_list: [
      { status: "", label: ":: Selecione ::" },
      { status: "not_payment", label: "NÃO COMISSIONADO" },
      { status: "ATIVO", label: "ATIVO" },
      { status: "INATIVO", label: "INATIVO" },
      { status: "CANCELED", label: "CANCELADO" },
      { status: "SENDED_PROPOSAL", label: "PROPOSTA ENVIADA" },
      { status: "REQUEST_PROPOSAL", label: "PROPOSTA SOLICITADA" },
      { status: "NOT_HOLDER", label: "NÃO É O TITULAR" },
      { status: "AGUARDANDO_CONTA", label: "AGUARDANDO CONTA" },
      { status: "MULTIPLAS_CONTAS", label: "MULTIPLAS INSTALAÇÕES" },
      {
        status: "AGUARDANDO_NRO_INSTALACAO",
        label: "AGUARDANDO NRO INSTALAÇÃO",
      },
      { status: "SEM_RETORNO", label: "SEM RETORNO" },
      { status: "QUALIFICAR_MANUALMENTE", label: "QUALIFICAR MANUALMENTE" },
      { status: "PAYMENT_METHOD_NOT_SELECTED", label: "SEM FORMA DE PAGTO" },
      { status: "IN_QUEUE", label: "NA FILA" },
      { status: "CANCELING", label: "EM CANCELAMENTO" },
      {
        status: "WAIT_ADD_CREDIT_CARD",
        label: "AGUARDANDO INCLUSAO DE CARTAO",
      },
      { status: "VALIDAR_DOCUMENTO", label: "VALIDAR DOCUMENTO" },
      { status: "AGUARDANDO_DOCUMENTO", label: "AGUARDANDO DOCUMENTO" },
      { status: "NAO_INTERESSADO", label: "NÃO INTERESSADO" },
      { status: "DESQUALIFICAR", label: "DESQUALIFICADO" },
      { status: "QUALIFICAR", label: "QUALIFICAR" },
      { status: "VALIDAR_CONTA", label: "VALIDAR CONTA/UC" },
      { status: "SALE_PENDING", label: "AGUARDANDO VENDA" },
    ],

    menu1: false,
    menu2: false,
    // loading: false,
    // loading_search: false,
  }),
  computed: {
    ...mapState("sales", ["loading", "sales", "filters"]),
    ...mapGetters(["loggedUser"]),
    computed_dt_inicialFormatted() {
      return this.formatDate(this.dt_inicial);
    },
    computed_dt_finalFormatted() {
      return this.formatDate(this.dt_final);
    },
    hasSellers() {
      if (this.loggedUser && this.loggedUser.group) {
        if (
          Array.isArray(this.loggedUser.group) &&
          (this.loggedUser.group.indexOf("admin") >= 0 ||
            this.loggedUser.group.indexOf("sales_partner_management") >= 0 ||
            this.loggedUser.group.indexOf("sales_management") >= 0)
        ) {
          return true;
        } else if (
          this.loggedUser.group === "admin" ||
          this.loggedUser.group === "sales_partner_management" ||
          this.loggedUser.group === "sales_management"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    dt_inicial() {
      this.dt_inicialFormatted = this.formatDate(this.dt_inicial);
      let new_finalDate = new Date(this.dt_inicial);
      let new_date = new_finalDate.setDate(new_finalDate.getDate() + 30);
      this.dt_final = new Date(new_date).toISOString().substr(0, 10);
    },
    dt_final() {
      this.dt_finalFormatted = this.formatDate(this.dt_final);
    },
  },
  mounted() {
    if (
      this.loggedUser &&
      this.loggedUser.group &&
      Array.isArray(this.loggedUser.group)
    ) {
      if (
        this.loggedUser.group.indexOf("admin") >= 0 ||
        this.loggedUser.group.indexOf("sales_management") >= 0
      ) {
        this.getSellers();
      }
    } else if (this.loggedUser && this.loggedUser.group) {
      if (
        this.loggedUser.group === "admin" ||
        this.loggedUser.group === "sales_management"
      ) {
        this.getSellers();
      }
    }
    if (this.filters) {
      this.seller = this.filters.email_seller;
      this.email = this.filters.email;
      this.cpf = this.filters.cpf;
      this.status_filter = this.filters.status;
      this.dt_inicial =
        this.filters.dt_inicial || new Date().toISOString().substr(0, 10);
      this.dt_final =
        this.filters.dt_final || new Date().toISOString().substr(0, 10);
    }
  },
  methods: {
    ...mapActions("sales", ["getSalesByParams", "resetFilter"]),
    ...mapMutations("sales", ["setFilters"]),
    formatDate(date) {
      if (!date) return null;
      if (typeof date === "object") date = date.toISOString().substr(0, 10);
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async _search() {
      this.resetFilter();
      let params = {};
      if (this.hasSellers) {
        if (this.seller && this.seller.email !== "")
          params.email_seller = this.seller.email;
      } else {
        if (this.loggedUser.email) {
          params.email_seller = this.loggedUser.email;
        } else {
          alert("Erro: Vendendor não identificado!");
        }
      }
      if (this.cpf) {
        params.cpf = this.cpf;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.status_filter && this.status_filter.status) {
        params.status = this.status_filter.status;
      }

      if (this.dt_inicial) {
        if (this.dt_inicial) params.dt_inicial = this.dt_inicial;
        else params.dt_inicial = new Date().toISOString().substr(0, 10);

        if (this.dt_final) params.dt_final = this.dt_final;
        else params.dt_final = new Date().toISOString().substr(0, 10);
      }
      this.setFilters(params);
      await this.getSalesByParams(params);
    },
    _clear() {
      this.email = "";
      this.cpf = "";
      this.phone = "";
      this.status_filter = "";
      this.seller = "";
      this.dt_inicial = new Date().toISOString().substr(0, 10);
      this.dt_final = new Date().toISOString().substr(0, 10);
      this.resetFilter();
      return;
    },
    getSellers() {
      getSellers()
        .then((sellers) => {
          sellers.docs.map((seller) => {
            const data = {
              id: seller.id,
              ...seller.data(),
            };
            this.sellers.push(data);
          });
        })
        .catch((err) => {
          console.error("Erro ao buscar vendedores. ", err);
        });
    },
  },
};
</script>
